import { render } from "./ServerSection.vue?vue&type=template&id=17d4b921"
import script from "./ServerSection.vue?vue&type=script&lang=js"
export * from "./ServerSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__